import React from 'react'
import PropTypes from 'prop-types'
import Markdown from 'react-remarkable'

class MarkdownTr extends React.Component {
  render() {
    return(
      <tr>
        <th>
          {this.props.fieldName}
        </th>
        <td>
          <span className='word-break'>
            <Markdown source={this.props.fieldValue} />
          </span>
        </td>
      </tr>
    )
  }
}

MarkdownTr.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string
}

export default MarkdownTr
